<svg xmlns="http://www.w3.org/2000/svg" width="2" height="999" viewBox="0 0 2 999" fill="none">
  <path d="M1.00002 1282L1.00009 1" stroke="#D7CEC5" stroke-width="2" stroke-linecap="round" stroke-dasharray="1 8"/>
</svg>